const URLS = {
  0: {
    base: "reportes/admin/users?tipo=0",
    download: {
      url: `reportes/export/users?tipo=0`,
      label: "Descargar reporte de usuarios activos",
    },
  },
  1: {
    base: "reportes/admin/users?tipo=1",
    download: {
      url: `reportes/export/users?tipo=1`,
      label: "Descargar reporte de usuarios pendientes",
    },
  },
  2: {
    base: "reportes/admin/users?tipo=2",
    download: {
      url: `reportes/export/users?tipo=2`,
      label: "Descargar reporte de usuarios rechazados",
    },
  },
};

export default URLS;
